module.exports = __webpack_public_path__ + "static/media/psd.b0061733.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/psd.png
// module id = 77
// module chunks = 0